var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("p", [_vm._v("\n    " + _vm._s(_vm.getLocalizedText()) + "\n")])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }